import '@assets/sass/app.scss';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { appWithTranslation } from 'next-i18next';
import { Suspense } from 'react';
import Head from 'next/head';
import { AppProvider } from '@context/app';
import { WebshopProvider } from '@context/webshop';
import ToastContainer from '@components/ToastContainer';
import { ToastProvider } from '@context/toast';
import Router, { useRouter } from 'next/router';
import NProgress from 'nprogress'; //nprogress module
import 'nprogress/nprogress.css'; //styles of nprogress
import dynamic from 'next/dynamic';

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

const DynamicHeader = dynamic(() => import('@components/Header'), {
  suspense: true,
});
const DynamicFooter = dynamic(() => import('@components/Footer'), {
  suspense: true,
});

config.autoAddCss = false;

const Layout = ({ children }) => {
  const router = useRouter();
  const { id } = router.query;

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden relative">
      <Suspense fallback={`Loading...`}>
        {id && <DynamicHeader webShopToken={id} />}
        {children}
        {id && <DynamicFooter />}
      </Suspense>
    </div>
  );
};

function Webshop({ Component, pageProps }) {
  return (
    <>
      <Head>
        <title>Webshop</title>
      </Head>
      <AppProvider>
        <WebshopProvider>
          <ToastProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
            <ToastContainer />
          </ToastProvider>
        </WebshopProvider>
      </AppProvider>
    </>
  );
}

export default appWithTranslation(Webshop);
